/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

// Reservation Statuses
export const HOLD = 'HOLD';
export const HOLD_INDEFINITE = 'HOLD_INDEFINITE';
export const RESERVED = 'RESERVED';
export const PENDING_CHECKED_IN = 'PENDING_CHECKED_IN';
export const CHECKED_IN = 'CHECKED_IN';
export const PENDING_CHECKED_OUT = 'PENDING_CHECKED_OUT';
export const CHECKED_OUT = 'CHECKED_OUT';
export const PENDING_NOSHOW = 'PENDING_NOSHOW';
export const NOSHOW = 'NOSHOW';
export const MODIFIED = 'MODIFIED';
export const ALTERED = 'ALTERED';
export const PENDING_VOID = 'PENDING_VOID';
export const VOID = 'VOID';
export const PENDING_CANCELLATION = 'PENDING_CANCELLATION';
export const CANCELLED = 'CANCELLED';
export const PENDING_FULL_REFUND = 'PENDING_FULL_REFUND';
export const FULL_REFUND = 'FULL_REFUND';
export const PENDING_CLOSURE = 'PENDING_CLOSURE';
export const CLOSED = 'CLOSED';
export const PENDING_EARLY_DEPARTURE = 'PENDING_EARLY_DEPARTURE';
export const EARLY_DEPARTURE = 'EARLY_DEPARTURE';
export const PENDING_ALTERATION = 'PENDING_ALTERATION';
export const PENDING_MODIFICATION = 'PENDING_MODIFICATION';
export const REVERTED = 'REVERTED';
export const PENDING_ACCOUNT_TRANSFER = 'PENDING_ACCOUNT_TRANSFER';
export const ARCHIVED = 'ARCHIVED';
export const UNDO_CHECK_IN = 'UNDO_CHECK_IN';
export const TRANSFERRED = 'TRANSFERRED';
export const PENDING_PAYMENT = 'PENDING_PAYMENT';
export const PENDING_COMPLETION = 'PENDING_COMPLETION';
